/**
 * Telegram Mini App ichida ishlaganda ishlatiladigan host adapter.
 *
 * Telegram Web SDK `initData` ni inject qilishi mumkin — Android va Desktop da
 * darhol mavjud, iOS WKWebView da esa ~100-1500ms kechikadi. Shu uchun
 * `awaitMatch` va `login` ichida polling ishlatiladi.
 */

import { apiPost } from "@/api/client";
import { setToken } from "@/lib/auth";
import type { HostAdapter, LoginResponse, ThemeMode } from "./types";
import { pollFor } from "./wait";

function readInitData(): string | null {
  return window.Telegram?.WebApp?.initData || null;
}

export const telegramHost: HostAdapter = {
  id: "telegram",
  brandId: "default",

  match() {
    // Sync tekshiruv: faqat initData allaqachon tayyor bo'lsa
    return Boolean(readInitData());
  },

  async awaitMatch() {
    const data = await pollFor(readInitData);
    return Boolean(data);
  },

  async login(): Promise<LoginResponse> {
    const initData = await pollFor(readInitData);
    if (!initData) {
      // Telegram bridge ulgurmaganda — UnsupportedHostError o'rniga
      // aniqroq xato chiqaramiz; main.tsx uni "Telegram orqali oching" UI ga ko'rsatadi.
      throw new NotTelegramEnvironmentError();
    }
    const data = await apiPost<LoginResponse>("/MiniApp/TelegramLogin", { initData });
    setToken(data.token);
    return data;
  },

  getPreferredTheme(): ThemeMode | null {
    const scheme = window.Telegram?.WebApp?.colorScheme;
    return scheme === "dark" || scheme === "light" ? scheme : null;
  },
};

/**
 * Telegram muhiti topilmagan holda tashlanadi. `main.tsx` shu xatoni
 * "Telegram orqali oching" UI bilan alohida handle qiladi.
 */
export class NotTelegramEnvironmentError extends Error {
  constructor() {
    super("Ilova Telegram orqali ochilmagan");
    this.name = "NotTelegramEnvironmentError";
  }
}
